import { Component, OnInit } from '@angular/core';
import { Application } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Search } from '../../shared/user.model';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-godownquery',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.css']
})
export class GodownQueryComponent implements OnInit {

  s: Search;
  data : any = {};
  applicationlist : any = {};
  applicantionmoredetails : any = [];
  color : number = 0
  godownmaxDetails : any = [];
  GodownBundleNo : number = 0;
  GodownSerialNo : number = 0;
  BundleForm :any = [];
  userForm : NgForm;
  BundleList : any = {};
  likeOperator : boolean = false;
  
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute,private errorHandler: ErrorHandler,
    private formBuilder:ReactiveFormsModule, private fb : FormBuilder ) { 
    this.s = new Search();
  }

  ngOnInit() {
    
  }
  

  onSearch(s) {    
    this.color = 0; 
    this.applicantionmoredetails = [];
    this.BundleList = [];
   
    var searchText = this.s.SearchText;
     var searchCriteria = this.s.SearchCriteria;
     if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
       swal("Warning!", "Please enter the searchby  and search text.", "warning");
    else
     {                  
      document.getElementById('loader-spinner').style.display = "block";
      if(this.likeOperator == true)             
      {
         this.userService.GetApplicationGodownlistforquery(searchCriteria,searchText)
         .subscribe(
           (data:any) =>{            
             this.applicationlist = data.Result; 
             document.getElementById('loader-spinner').style.display = "none";                      
           }, (error) => {         
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          }
         )  
      }      
      else{
        this.userService.GetApplicationGodownlistforqueryOnEqual(searchCriteria,searchText)
         .subscribe(
           (data:any) =>{            
             this.applicationlist = data.Result; 
             document.getElementById('loader-spinner').style.display = "none";                      
           }, (error) => {         
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          }
         )  
      }               
     }
   }

   GetMoreDetails(Id,RegNo){
    document.getElementById('loader-spinner').style.display = "block";
    this.color = Id
     for(let i=0; i<this.applicationlist.length; i++){
       if(Id == this.applicationlist[i].APP_Id){
         this.applicantionmoredetails = this.applicationlist[i];              
         document.getElementById('loader-spinner').style.display = "none";            
       }
     }  
     
     this.getAllBundleList(RegNo);
   }

  //GetAllBundleList

  getAllBundleList(RegNo){
    this.userService.GetAllBundleList(RegNo)
    .subscribe(
      (data:any) =>{            
        this.BundleList = data.Result;                 
        //document.getElementById('loader-spinner').style.display = "none";                      
      }, (error) => {         
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    )  
  }

  handleChange(evt) {    
    var target = evt.target;
    if (target.checked) {
     this.likeOperator = true
    } else {
      this.likeOperator = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Godown/query/query.component.ts